import { Injectable } from '@angular/core';
import { EmployeeNotificationModalComponent } from '@cl/shared/components/employee-notification-modal/employee-notification-modal.component';
import { BaseModel, CommandResult, User } from '@cl/shared/models';
import { BaseEmployeeNotificationByUsers } from '@cl/shared/models/base/base-employee-notification.model';
import { EmployeeNotificationModalData } from '@cl/shared/models/misc/employee-notification-modal-data.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { lastValueFrom } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root',
})
export class EmployeeNotificationsService {
    constructor(
        private messageService: NzMessageService,
        private modalService: NzModalService,
    ) {}
    async sendEmployeeNotification<T extends BaseModel>(id: number, service: BaseService<T>): Promise<CommandResult<void>> {
        try {
            if (!this.messageService) {
                throw Error('No NzMessageService');
            }

            if (!this.modalService) {
                throw Error('No NzModalService');
            }

            const relatedUsers: User[] = (await service.getUsersRelatedToEntity(id)).data;

            const notificationModel: BaseEmployeeNotificationByUsers = new BaseEmployeeNotificationByUsers();
            notificationModel.entityId = id;

            const modalData: EmployeeNotificationModalData<BaseEmployeeNotificationByUsers> = {
                users: relatedUsers,
                notificationModel: notificationModel,
            };

            const modal: NzModalRef<any> = this.modalService.create({
                nzTitle: 'Paziņojums darbiniekam',
                nzContent: EmployeeNotificationModalComponent,
                nzData: modalData,
            });

            const notificationOptions: BaseEmployeeNotificationByUsers = await lastValueFrom(modal.afterClose);
            if (!notificationOptions) {
                return;
            }

            try {
                await service.dispatchEmployeeNotification(notificationOptions);
                this.messageService.success('Paziņojums veiksmīgi nosūtīts');
            } catch (ex) {
                console.error(ex);
                if (ex.error?.errors) {
                    ex.error.errors.forEach((error) => {
                        this.messageService.error(error);
                    });
                    return;
                }

                this.messageService.error('Neizdevās nosūtīt paziņojumu darbiniekam');
                return;
            }
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                return;
            }

            this.messageService.error('Neizdevās nosūtīt paziņojumu darbiniekam');
            return;
        }
    }
}
